module.exports = __webpack_public_path__ + "img/0Q3A6289_L_Wood_MockedUp.7d4eb882.jpg";